import { render, staticRenderFns } from "./DepotStatistics.vue?vue&type=template&id=1d8ed70f&"
import script from "./DepotStatistics.vue?vue&type=script&lang=js&"
export * from "./DepotStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports